import React, { useState } from "react";
import { Button, ButtonRow, ContextMenu, ContextMenuItem, Heading } from "cai-fusion";

import { useFacts } from "../../contexts/FactsContext";
import env from "../../../../configs/envConfig";

import { ReactComponent as IconTrash } from "../../../../images/icon-trash.svg";
import { ReactComponent as IconDraft } from "../../../../images/icon-draft.svg";

const FactsControl = () => {
    const { facts, createFact } = useFacts();

    // Visual state for displaying the "new fact" portion of the page.
    // This is a duplicate of the edit, but is not associated with any given fact.
    const [isCreatingFact, setIsCreatingFact] = useState(false);
    // Text field for the new fact text.
    const [newFactText, setNewFactText] = useState("");

    return (
        <>
            <div className="row l-mt-sm">
                <div className="col-12">
                    <div className="l-row l-row--justify-between l-row--align-center">
                        <div className="col-md-9">
                            <Heading size={3}>Facts</Heading>
                            <p className="a-muted-text">Manage the facts that {env.REACT_APP_BRANDING_SYMPHONY_NAME ?? "Maestro"} should know about itself.</p>
                        </div>
                        <div className="col-md-3">
                            <ButtonRow>
                                <Button
                                    children="Add Fact"
                                    onClick={() => setIsCreatingFact(true)}
                                />
                            </ButtonRow>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div id="factsContainer">
                        {isCreatingFact &&
                            <div className="o-block l-mt-sm l-mb-sm">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="m-form-group">
                                            <label className="a-label">Fact</label>
                                            <textarea 
                                                className="a-textarea-input" 
                                                id="fact-input" 
                                                rows="3" 
                                                placeholder="Enter Fact"
                                                value={newFactText}
                                                onChange={(e) => setNewFactText(e.target.value)}
                                            />
                                        </div>
                                        <ButtonRow>
                                            <Button 
                                                outline
                                                children="Cancel"
                                                onClick={() => {
                                                    setIsCreatingFact(false);
                                                    setNewFactText("");
                                                }}
                                            />
                                            <Button
                                                children="Create"
                                                onClick={() => {
                                                    setIsCreatingFact(false);
                                                    createFact(newFactText);
                                                    setNewFactText("");
                                                }}
                                            />
                                        </ButtonRow>
                                    </div>
                                </div>
                            </div>
                        }
                        {facts.map((fact) => {
                            return (
                                <FactTab fact={fact} key={fact?.id ?? ""} />
                            )
                        })}
                    </div>
                </div>
            </div>
        </>
    );
}


const FactTab = ({fact}) => {
    const [isEditing, setIsEditing] = useState(false);
    const [contextMenuIsHidden, setContextMenuIsHidden] = useState(true);

    const [factText, setFactText] = useState(fact?.value ?? "");

    const { updateFact, deleteFact } = useFacts();

    if (!isEditing) {
        return (
            <div className="o-block l-mt-sm" key={fact?.id ?? ""}>
                <div className="row">
                    <div className="col-10">
                        <p>{fact?.value ?? ""}</p>
                    </div>
                    <div className="col-2 h-vert-center-right">
                        <ContextMenu
                            isHidden={contextMenuIsHidden}
                            onClick={() => setContextMenuIsHidden(!contextMenuIsHidden)}
                            onBlur={() => setContextMenuIsHidden(true)}
                        >
                            <ContextMenuItem 
                                Icon={IconDraft}
                                name="Edit Fact"
                                onClick={() => {
                                    setFactText(fact?.value ?? "");
                                    setIsEditing(true);
                                    setContextMenuIsHidden(true);
                                }}
                            />
                            <ContextMenuItem
                                Icon={IconTrash}
                                danger
                                name="Delete Fact"
                                onClick={() => {
                                    deleteFact(fact.id);
                                    setContextMenuIsHidden(true);
                                }}
                            />
                        </ContextMenu>
                    </div>
                </div>
            </div>
        )
    }
    else {
        return (
            <div className="o-block l-mt-sm l-mb-sm">
                <div className="row">
                    <div className="col-12">
                        <div className="m-form-group">
                            <label className="a-label">Fact</label>
                            <textarea 
                                className="a-textarea-input" 
                                id="fact-input"
                                rows="3" 
                                placeholder="Enter Fact"
                                value={factText}
                                onChange={(e) => setFactText(e.target.value)}
                            />
                        </div>
                        <ButtonRow>
                            <Button 
                                outline
                                children="Cancel"
                                onClick={() => {
                                    setIsEditing(false);
                                    setFactText("");
                                }}
                            />
                            <Button
                                children="Save"
                                onClick={() => {
                                    setIsEditing(false);
                                    updateFact(fact.id, {...fact, value: factText});
                                }}
                            />
                        </ButtonRow>
                    </div>
                </div>
            </div>
        );
    }
}

export default FactsControl;